/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosInstance } from "axios";
import { Result } from "../../../Shared/Protocol/protocol-result";
import { IOrderReplacementEntity, IOrdersReplacementListPayload, IOrdersReplacementListResponse, IPayloadOrderReplacement, IPayloadUpdateOrderReplacement } from "../orders-replacement/orders-replacement.interface";
import { Environment } from "../../../Config/constants";
import { ICreatePricePoliciesPayload, ICreateRulesPoliciesPayload, IDestroyRulesPoliciesPayload, IPricePoliciesEntity, IPricePoliciesListPayload, IPricePoliciesListResponse, IUpdatePricePoliciesPayload, IUpdateRulesPoliciesPayload } from "./price-policies.interface";
import { normalizePricePoliciesListResponse } from "../../../utils/fetch-all-price-policies";

export class PricePoliciesApiRemoteService {
  constructor(private service: AxiosInstance) {}
    
  public updateRule = async ({ policyId, ruleId, ...rest }: IUpdateRulesPoliciesPayload): Promise<Result<void>> => {
    try {
        await this.service.put(`/price-policies/${policyId}/rules/${ruleId}`, { ...rest});

      return Result.ok();
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public update = async ({ policyId, ...rest }: IUpdatePricePoliciesPayload): Promise<Result<void>> => {
    try {
        await this.service.put(`/price-policies/${policyId}`, { ...rest});

      return Result.ok();
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public create = async (data: ICreatePricePoliciesPayload): Promise<Result<IPricePoliciesEntity>> => {
    try {
        const response = await this.service.post(`/price-policies`, data);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public createRules = async ({policyId, ...data}: ICreateRulesPoliciesPayload): Promise<Result<void>> => {
    try {
        await this.service.post(`/price-policies/${policyId}/rules`, data);

      return Result.ok();
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public list = async ({ page, searchBy, offset }: IPricePoliciesListPayload): Promise<Result<IPricePoliciesListResponse>> => {
    try {
        const response = await this.service.get(`/price-policies`, { 
          params: {
            offset: offset ?? Number(Environment.OFFSET_REGISTERS),
            page,
            searchBy,
          }
        });

      return Result.ok(normalizePricePoliciesListResponse(response.data));
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public show = async (policyId: string): Promise<Result<IPricePoliciesEntity>> => {
    try {
        const response = await this.service.get(`/price-policies/${policyId}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public destroyRule = async ({policyId, ruleId}: IDestroyRulesPoliciesPayload): Promise<Result<void>> => {
    try {
        const response = await this.service.delete(`/price-policies/${policyId}/rules/${ruleId}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public destroy = async (policyId: string): Promise<Result<void>> => {
    try {
        const response = await this.service.delete(`/price-policies/${policyId}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public reSync = async (policyId: string): Promise<Result<void>> => {
    try {
      const response = await this.service.post(`/price-policies/${policyId}/trigger-products-update`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };
}
